import React, { ReactElement, useState, forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import { DatePickerHeader } from "./DatePickerHeader/DatePickerHeader";

import "react-datepicker/dist/react-datepicker.css";
import styles from "./CalendarDoubleDatePicker.module.scss";
import { Button } from "@kursk/components/ui/Button/Button";
import moment from "moment";
import { fixTimezoneDiff } from "@kursk/utils/fixTimezoneDiff";

registerLocale('ru', ru);

interface IProps {
  date: number;
  onChangeDate: (date: number[]) => void;
  customInput: (props) => ReactElement;
  enabledDays?: number[];
  disablePastDates?: boolean;
  lastDate?: number;
}

export const CalendarDoubleDatePicker = forwardRef<ReactElement, IProps>(({
  date,
  onChangeDate,
  customInput,
  enabledDays,
  disablePastDates,
  lastDate,
}: IProps, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const filterDates = (date) => {
    const newDate = fixTimezoneDiff(date);
    let condition1 = true;
    let condition2 = true;
    let condition3 = true;
    if (enabledDays?.length) {
      condition1 = enabledDays.indexOf(newDate) !== -1;
    }
    if (disablePastDates) {
      condition2 = (moment().isBefore(newDate) ||
        moment().startOf('day').valueOf() ===
        moment(newDate).startOf('day').valueOf());
    }
    if (lastDate) {
      condition3 = (moment(lastDate).isAfter(newDate) || lastDate === newDate);
    }
    return condition1 && condition2 && condition3;
  };

  const onClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const onSubmit = () => {
    const arr: number[] = [];
    if (startDate) {
      arr.push(fixTimezoneDiff(startDate));
    }
    if (endDate) {
      arr.push(fixTimezoneDiff(endDate));
    }
    onChangeDate(arr);
  };

  return (
    <div className={styles.calendarWrapper}>
      <DatePicker
        ref={ref}
        locale='ru'
        key={date}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        filterDate={filterDates}
        customInput={customInput({ isOpen })}
        onCalendarOpen={() => setIsOpen(true)}
        onCalendarClose={() => setIsOpen(false)}
        disabledKeyboardNavigation
        shouldCloseOnSelect={false}
        renderCustomHeader={DatePickerHeader}
        calendarContainer={({ className, children }) => (
          <div className={className}>
            <div className={styles.paddingWrap}>
              {children}
            </div>
            <div className={styles.buttonWrap}>
              <div className={styles.clearBtn} onClick={() => onClear()}>
                Очистить
              </div>
              <Button className={styles.button} onClick={onSubmit} text='Применить'></Button>
            </div>
          </div>
        )}
        dayClassName={() => 'react-datepicker__day--custom'}
        popperPlacement="bottom-end"
        fixedHeight
        monthsShown={2}
        selectsRange
      />
    </div>
  )
})
